export default {"src":"/_next/static/media/cabin.0da264ba.svg","height":47,"width":37,"blurWidth":0,"blurHeight":0};